




import { Component, Vue, Watch } from "vue-property-decorator";
import { patchClassValidatorI18n } from "../models/validation/translateErrors";

@Component({
	name: "main-router",
	components: {},
})
export default class Main extends Vue {
	private mounted() {
		patchClassValidatorI18n(this.$i18n.locale);
	}
}
